// Gemeinsame kleine Bausteine der Belege-Oberflaeche (Formatierung, Status-Chip, Dialoge). Nutzt die vorhandenen Finanz-Styles (fs) und das THEME.
import { useState } from "react";
import THEME from "../../theme";
import { fs } from "../finanzen/utils/styles";
import { STATUS_NAME } from "./belegeApi";

export const STATUS_FARBE = {
  eingegangen: THEME.colors.textMuted, geprueft: THEME.colors.primary, bankumsatz_zugeordnet: THEME.colors.accent,
  an_datev_gesendet: THEME.colors.warning, in_datev_bestaetigt: THEME.colors.success,
  abgelehnt: THEME.colors.danger, dublette: THEME.colors.danger, rueckfrage: THEME.colors.warning,
};
export const euro = (n) => (n === null || n === undefined ? "–" : Number(n).toLocaleString("de-DE", { style: "currency", currency: "EUR" }));
export const datum = (d) => (d ? new Date(d).toLocaleDateString("de-DE") : "–");
export const datumZeit = (d) => (d ? new Date(d).toLocaleString("de-DE") : "–");

export function Chip({ status, text, farbe }) {
  const f = farbe || STATUS_FARBE[status] || THEME.colors.border;
  return <span style={{ border: `1px solid ${f}`, color: f, borderRadius: 999, padding: "2px 10px", fontSize: THEME.fontSize.sm, display: "inline-block", maxWidth: "100%", overflowWrap: "anywhere" }}>{text || STATUS_NAME[status] || status}</span>;
}

export function Meldung({ fehler, hinweis }) {
  return (
    <>
      {fehler && <div role="alert" style={{ color: THEME.colors.danger, marginBottom: 12 }}>{fehler}</div>}
      {hinweis && <div role="status" style={{ color: THEME.colors.success, marginBottom: 12 }}>{hinweis}</div>}
    </>
  );
}

export function Karte({ titel, rechts, children, stil }) {
  return (
    <div style={{ ...fs.karte, padding: "1rem 1.25rem", ...stil }}>
      {(titel || rechts) && (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 10 }}>
          <strong>{titel}</strong>{rechts}
        </div>
      )}
      {children}
    </div>
  );
}

export function Klein({ children, farbe }) {
  return <div style={{ color: farbe || THEME.colors.textSecondary, fontSize: THEME.fontSize.sm, marginTop: 4, overflowWrap: "anywhere" }}>{children}</div>;
}

export function Modal({ titel, children, onSchliessen, breite = 420 }) {
  return (
    <div role="dialog" aria-label={titel} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 16 }}>
      <div style={{ background: THEME.colors.surface, borderRadius: THEME.radius.xl, padding: 24, maxWidth: breite, width: "100%", maxHeight: "92vh", overflow: "auto" }}>
        <h3 style={{ marginTop: 0 }}>{titel}</h3>
        {children}
        {onSchliessen && <div style={{ marginTop: 12 }}><button style={fs.btnGray} onClick={onSchliessen}>Abbrechen</button></div>}
      </div>
    </div>
  );
}

// Eigener Bestaetigungsdialog (window.confirm ist in installierten Web-Apps unzuverlaessig). "text" erklaert die Folgen; optional mit Pflicht-Texteingabe (grund) oder Passwort.
export function Bestaetigung({ titel, text, okText = "Bestätigen", gefahr = false, grundPflicht = 0, passwort = false, onOk, onAbbruch }) {
  const [grund, setGrund] = useState("");
  const [pw, setPw] = useState("");
  const [haken, setHaken] = useState(false);
  const bereit = (!grundPflicht || grund.trim().length >= grundPflicht) && (!passwort || pw.length > 0);
  return (
    <Modal titel={titel} onSchliessen={onAbbruch}>
      <div style={{ color: THEME.colors.textSecondary, marginBottom: 12, whiteSpace: "pre-line" }}>{text}</div>
      {grundPflicht > 0 && <input autoFocus style={{ ...fs.input, width: "100%", marginBottom: 10 }} placeholder="Begründung" value={grund} onChange={e => setGrund(e.target.value)} />}
      {passwort && <input type="password" autoComplete="current-password" autoFocus style={{ ...fs.input, width: "100%", marginBottom: 10 }} placeholder="Dein Passwort zur Bestätigung" value={pw} onChange={e => setPw(e.target.value)} />}
      {gefahr && <label style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 10, color: THEME.colors.warning }}><input type="checkbox" checked={haken} onChange={e => setHaken(e.target.checked)} /> Ja, ich habe das gelesen.</label>}
      <button style={gefahr ? { ...fs.btn, background: THEME.colors.danger } : fs.btn} disabled={!bereit || (gefahr && !haken)} onClick={() => onOk({ grund: grund.trim(), passwort: pw })}>{okText}</button>
    </Modal>
  );
}

export function Reiterleiste({ eintraege, aktiv, onWaehle }) {
  return (
    <div role="tablist" style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 16 }}>
      {eintraege.map(e => (
        <button key={e.key} role="tab" aria-selected={aktiv === e.key} onClick={() => onWaehle(e.key)}
          style={{ ...fs.btnGray, padding: "8px 14px", background: aktiv === e.key ? THEME.colors.primary : THEME.colors.surfaceMuted, color: THEME.colors.text }}>
          {e.label}{e.zahl ? <span style={{ marginLeft: 6, background: THEME.colors.warning, color: "#000", borderRadius: 999, padding: "0 7px", fontSize: THEME.fontSize.sm }}>{e.zahl}</span> : null}
        </button>
      ))}
    </div>
  );
}

// Fuehrt eine Aktion aus, meldet Fehler/Erfolg und laedt danach neu.
export function useAktion(setFehler, setHinweis) {
  return async (fn, erfolg) => {
    setFehler(""); if (setHinweis) setHinweis("");
    try { const r = await fn(); if (erfolg && setHinweis) setHinweis(typeof erfolg === "function" ? erfolg(r) : erfolg); return r; }
    catch (e) { setFehler(e.message); return undefined; }
  };
}
